/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceStandardScopeQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ComplianceStandardScopeQueryOperator");
    }

    getFixupPrototypeFunction() { return ComplianceStandardScopeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ComplianceStandardScopeQueryOperator>): ComplianceStandardScopeQueryOperator {
        let obj = Object.assign(new ComplianceStandardScopeQueryOperator(), model);
        ComplianceStandardScopeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceStandardScopeQueryOperator>): ComplianceStandardScopeQueryOperator {
        if (!model) return null;
        return ComplianceStandardScopeQueryOperator.newInstance(<ComplianceStandardScopeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceStandardScopeQueryOperator) {
        if (!obj) return;

        models.ComplianceStandardScopeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceStandardScopeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ComplianceStandardScopeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Scopes to include
     */
    scopes: Array<models.ComplianceStandardScope>;

}
